<template>
  <div>
    <base-title :title="pageTitle" :subtitle="pageSubtitle">
      <base-button
        :text="editMode ? 'Descartar edição' : 'Limpar'"
        design="two"
        @click="clearAll"
        :class="{ 'reverse w-100': !!isMobile }"
      />
    </base-title>

    <div class="row" id="catalog">
      <div class="col-lg-8" id="catalog-products">
        <div class="customer-box">
          <base-box
            v-if="!selectedCustomer || !selectedCustomer.phone"
            class="customer-search"
          >
            <p class="customer-icon">
              <i class="fal fa-user-circle"></i>
            </p>
            <base-input
              v-if="saleType == 1"
              v-model="phone"
              ref="searchClient"
              @blur="searchClientFromTel"
              @keyup="searchClientFromTel"
              :label="'Telefone do cliente'"
              :masked="true"
              :mask="['(##) ####-####', '(##) #####-####']"
              class="w-100 mb_0 pt_0"
              :design="'two'"
            />
          </base-box>

          <base-box v-else class="customer-found">
            <div
              @click="
                if (!editMode) drawers.customer.open = !drawers.customer.open;
              "
              :class="{ 'block-edit': editMode }"
            >
              <div class="customer-main">
                <p class="customer-icon">
                  <i class="fal fa-user-circle"></i>
                </p>
                <div>
                  <div class="d-flex">
                    <p class="customer-name">
                      {{
                        selectedCustomer.name ||
                        (!selectedCustomer.id && 'Novo cliente')
                      }}
                    </p>
                  </div>

                  <p class="customer-phone">
                    <span>{{ Utils.phoneMask(selectedCustomer.phone) }}</span>
                    <!-- Se tem algum indicador -->
                    <!-- Se é o primeiro pedido -->
                    <span
                      class="mx_10"
                      v-if="!hasOrder || isBirthday || hasAnnotation"
                      >/</span
                    >
                    <i
                      v-if="!hasOrder"
                      class="fal fa-medal indicator"
                      title="Primeiro pedido"
                    ></i>
                    <!-- Se é aniversáriante -->
                    <i
                      v-if="isBirthday"
                      class="fal fa-birthday-cake indicator"
                      title="Aniversáriante"
                    ></i>
                    <!-- Se tem anotações -->
                    <i
                      v-if="hasAnnotation"
                      class="far fa-sticky-note indicator"
                      :title="annotationsList"
                    ></i>
                  </p>
                </div>
              </div>
            </div>

            <div class="h-100 w-100 d-show" style="margin-left: 70px">
              <div class="customer-address w-100">
                <base-select
                  ref="addressRef"
                  :title="'Endereço de entrega'"
                  class="w-100 mb_0"
                  style="margin-top: -10px"
                  v-model="selectedDeliveryAddress"
                  @change="setSelectedDeliveryAddress"
                >
                  <option
                    @change="setSelectedDeliveryAddress"
                    v-if="componentMounted || selectedCustomer.addresses"
                    :value="-1"
                    selected
                  >
                    Retirar na loja fisica.
                  </option>
                  <option
                    :value="index"
                    v-for="(address, index) in selectedCustomer.addresses"
                    :key="index"
                  >
                    {{ formatAddress(address) }}
                  </option>
                </base-select>
              </div>
            </div>
          </base-box>
        </div>

        <!-- Tabs mobile -->
        <!-- <div v-if="isMobile" class="relative">
                    <base-tabs :tabs="tabs" @change="changeTab"/>
                    <div v-if="cartAlert" class="cart-alert"></div>
        </div>-->

        <!--
			TO DO:

			- Colocar classe empty na base-box abaixo, quando não houver nenhuma categoria.
        -->
        <base-box
          v-if="!isMobile || tabOrder"
          class="construction m_0 pb_0"
          :class="{ mb_45: isMobile && order.cart.catalog.items.length > 0 }"
        >
          <div class="cc-title mb_30">
            <base-label
              v-if="getCategoryList().length > 0"
              :text="
                !selectedCategory
                  ? StringLanguage.selectACategory
                  : StringLanguage.selectAProduct
              "
              class="mb_0"
              style="line-height: 16px"
            />
            <div>
              <p
                class="action-right"
                v-if="selectedCategory"
                @click="clearSelection"
              >
                {{ StringLanguage.back }}
              </p>
              <div />
            </div>
          </div>

          <div
            class="empty-catalog"
            v-if="getCategoryList().length == 0 || getItems().length == 0"
          >
            <p>{{ StringLanguage.catalogEmpty }}</p>
            <router-link to="/cardapio" class="link-catalog">{{
              StringLanguage.gotoCatalog
            }}</router-link>
          </div>

          <div class="row box-categories">
            <div
              class="col-lg-3 col-xs-12"
              v-for="(item, i) in getItems()"
              :key="i"
            >
              <div
                v-if="item.type == 'category'"
                class="box-selection"
                @click="selectCategory(item)"
                :title="item.name"
              >
                <p
                  class="name"
                  v-if="item.mode === 'drink' && item.sizes.length == 1"
                >
                  {{ getDrinkName(item) }}
                </p>
                <p class="name" v-else>{{ item.name }}</p>
              </div>
              <div
                v-else
                class="box-selection"
                @click="selectProduct(item)"
                :title="item.name"
              >
                <p
                  class="name"
                  v-if="item.type === 'drink' && item.sizes.length == 1"
                >
                  {{ `${item.name} - ${item.sizes[0].name}` }}
                </p>
                <p class="name" v-else>{{ item.name }}</p>
              </div>
            </div>
          </div>
        </base-box>
      </div>

      <div v-if="!isMobile || tabOrder === false" class="col-lg-4" id="cart">
        <base-box
          class="cart relative m_0"
          :class="{ empty: order.cart.catalog.items.length < 1 }"
        >
          <div class="cc-title">
            <base-label text="Carrinho" />
          </div>

          <!--
              Atenção:
              - Cart-content também existe dentro de Drawer no mobile.
          -->
          <div class="cart-content">
            <orders-products
              v-if="order.cart.catalog.items.length > 0"
              :catalog="catalog"
              :items="order.cart.catalog.items"
              :remove="removeItems"
              :cart="true"
              class="py_10"
              @itemRemoved="onRemoveCartItem"
              @itemQuantity="onChangeCartItemQuantity"
            />

            <div v-else class="empty-cart">
              <i class="fal fa-shopping-cart" />
              <p>{{ StringLanguage.cartEmpty }}</p>
            </div>

            <div id="cartContent"></div>
          </div>
          <div class="finish-order" v-if="order.cart.catalog.items.length > 0">
            <div>
              <div class="total">
                <p>TOTAL</p>
                <p>{{ Utils.convertMoney(order.cart.total) }}</p>
              </div>
            </div>
            <base-button
              :text="editMode ? 'Continuar edição' : 'Finalizar pedido'"
              @click.native="validCheckout()"
              class="big"
            />
            <!-- Só quando é possível finalizar -->
          </div>
        </base-box>
      </div>
    </div>

    <!-- Cart mobile fixed -->
    <div
      v-if="isMobile && order.cart.catalog.items.length > 0"
      class="cart-mobile"
      @click="drawers.cart.open = !drawers.cart.open"
    >
      <p class="text-left">
        <span class="itens-qty">{{ order.cart.catalog.items.length }}</span>
      </p>
      <p>Ver carrinho</p>
      <p class="text-right">{{ Utils.convertMoney(order.cart.total) }}</p>
    </div>
    <!-- final Cart mobile -->

    <!-- DRAWERS -->

    <!-- Customer drawer -->
    <sales-customer-drawer
      :index="drawers.customer.index"
      :open="drawers.customer.open"
      :phone="drawers.customer.phone"
      :customers="customers"
      :customer="selectedCustomer"
      :storeConfigurations="configurations"
      @setCustomer="setCustomer"
      @onCloseCustomerDrawer="onCloseCustomerDrawer"
    />

    <!-- Order drawer -->
    <sales-order
      ref="salesOrder"
      :category="selectedCategory"
      :product="selectedProduct"
      :open="drawers.order.open"
      :title="`${selectedCategory ? selectedCategory.name : ''} - ${
        selectedProduct ? selectedProduct.name : ''
      }`"
      :onClose="clearSelectionProduct"
      @addCart="addItem"
    />

    <!-- Finish drawer -->

    <base-drawer
      :open="drawers.finish.open"
      :close="drawers.finish.close"
      @onClose="closeOrderDrawer()"
      :title="getTitle()"
    >
      <sales-finish
        v-if="drawers.finish.show"
        ref="salesfinish"
        :configurations="configurations"
        :selected-delivery-address="selectedDeliveryAddress"
        :order="order"
        :customer="selectedCustomer"
        :payments="configurations.payment_methods"
        @finish="finish"
        @addressChanged="
          (selected) => (this.selectedDeliveryAddress = selected)
        "
      />

      <template slot="footer" v-if="!orderStatusResponse && !hideFooter">
        <div
          class="d-flex align-center"
          :class="currentStep === 0 ? 'justify-end' : 'justify-between'"
        >
          <base-button
            design="four"
            class="mr_5 big"
            @click="handlePrevStepFinish"
            v-if="currentStep === 1"
          >
            <span>Anterior</span>
          </base-button>

          <base-button class="ml_5 big" @click="handleNextStepFinish">
            <span v-if="currentStep === 1">Finalizar</span>
            <span v-else>Próximo</span>
          </base-button>
        </div>
      </template>

      <template slot="footer" v-if="!!orderStatusResponse && !hideFooter">
        <div class="d-flex align-center">
          <base-button class="big w-100" @click="closeOrderDrawer()">
            <span>Fechar</span>
          </base-button>
        </div>
      </template>
    </base-drawer>

    <!-- Carrinho mobile -->
    <base-drawer
      v-if="isMobile"
      :open="drawers.cart.open"
      :close="drawers.cart.close"
      :title="'Carrinho'"
      :direction="'bottom'"
      :time="'0.2'"
    >
      <base-card class="pt_20 pb_60">
        <div class="cart-content-mobile">
          <orders-products
            v-if="order.cart.catalog.items.length > 0"
            :items="order.cart.catalog.items"
            :catalog="catalog"
            :remove="removeItems"
            @itemRemoved="onRemoveCartItem"
            @itemQuantity="onChangeCartItemQuantity"
            :cart="true"
            class="py_10"
          />
          <div v-else class="empty-cart">
            <p>{{ StringLanguage.cartEmpty }}</p>
          </div>
        </div>
      </base-card>

      <template v-slot:footer>
        <div class="d-flex">
          <base-button
            :text="editMode ? 'Continuar edição' : 'Finalizar pedido'"
            @click.native="openCheckout()"
            class="w-100 big"
          />
        </div>
      </template>
    </base-drawer>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Builder from 'easyjs/lib/Schema/Components/Builder';
import { UserFlag } from 'easyjs/lib/Schema/Account/UserFlag';
import Order from 'easyjs/lib/Schema/Order';
import { Role } from 'easyjs/lib/Role/Group';
import Vue from 'vue';
import Geolocation from 'easyjs/lib/Schema/Address/Geolocation';
import Delivery, { DeliveryType } from 'easyjs/lib/Schema/Delivery/index';
import AppBridge from '@/plugins/app';
import { getXAPIEnv } from '@/plugins/account';
import BaseTitle from '@/components/Title';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseLabel from '@/components/Label';
import BaseCard from '@/components/Card';
import BaseSelect from '@/components/Select';
import BaseDrawer from '@/components/Drawer';
import BaseButton from '@/components/Button';
import BaseTabs from '@/components/Tabs';
import BaseQuestion from '@/components/Question';

import SalesCustomerDrawer from '@/containers/Sales/SalesCustomerDrawer';
import SalesCustomer from '@/containers/Sales/SalesCustomer';
import SalesSelectCustomer from '@/containers/Sales/SalesSelectCustomer';
import SalesOrder from '@/containers/Sales/SalesOrder';
import SalesFinish from '@/containers/Sales/SalesFinish';
import CatalogAPI from '@/api/catalog';

import OrdersProducts from '@/containers/Orders/OrdersProducts';

import CustomerApi from '@/api/customer';
import AccountApi from '@/api/account';
import UserApi from '@/api/user';
import OrderApi from '@/api/order';

import Utils from '@/utils';
import Storage2 from '@/plugins/storage2';

import Location from '@/plugins/core/schema/configurations/BasicInfo/Location';
import DesktopBridge from '@/plugins/desktop';
import { Print as DesktopPrint } from '@/plugins/print';
import router from '../router';

export default {
  data() {
    return {
      Role,
      Utils,
      orderStatusResponse: null,
      hideFooter: false,
      pageTitle: 'Atendimento',
      pageSubtitle: '',
      editMode: false,
      selectedDeliveryAddress: -1,
      order: this.createEmptyOrder(),
      drawers: {
        customer: {
          show: false,
          open: false,
          index: 1,
          phone: null,
        },
        order: {
          open: false,
        },
        finish: {
          show: false,
          open: false,
          close: false,
        },
        cart: {
          open: false,
          close: false,
        },
      },
      tabs: [
        {
          name: 'Pedido',
          value: true,
        },
        {
          name: 'Carrinho',
          value: false,
          count: 0,
        },
      ],
      tabOrder: true,
      catalog: null,
      selectedCategory: null,
      selectedProduct: null,
      removeItems: [],
      foundCustomer: false, // Variável provisória para mostrar o que aparece e o que não, quando o cliente é encontrado.
      saleType: 1,
      phone: '',
      selectedCustomer: {},
      customers: [],
      cartAlert: false,
      hasIndicator: false,
      hasOrder: false,
      isBirthday: false,
      hasAnnotation: false,
      annotationsList: 'Há anotações',
      componentMounted: false,
      oldselectedDeliveryAddress: 0,
      currentStep: 0,
    };
  },
  components: {
    BaseTitle,
    BaseBox,
    BaseInput,
    BaseLabel,
    BaseCard,
    BaseSelect,
    BaseDrawer,
    BaseButton,
    BaseTabs,
    BaseQuestion,
    SalesCustomer,
    SalesSelectCustomer,
    SalesCustomerDrawer,
    SalesOrder,
    SalesFinish,
    OrdersProducts,
  },
  mounted() {
    if (!this.isMobile) {
      this.$refs.searchClient.focus();
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      // Carrega o cardapio
      const response = await CatalogAPI.catalogCatalog(true, true);
      const catalog = Builder.mountSchema(
        response.getData({ type: 'catalog' })
      );

      Builder.executeOnSchema(catalog, (item) => {
        item.new = false;
        item.quantity = 0;
      });

      if (!catalog) {
        next(false);
      } else {
        next(async (vm) => {
          vm.catalog = catalog;

          if (vm.$route.params.orderId) {
            await vm.handleOrder();
          } else if (!vm.isMobile) {
            vm.$refs.searchClient.focus();
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    closeOrderDrawer() {
      this.$refs.salesfinish.showResponse(null);
      this.drawers.finish.close = !this.drawers.finish.close;
      this.drawers.finish.show = false;
      this.currentStep = 0;
      this.hideFooter = false;
      this.orderStatusResponse = null;
    },
    getTitle() {
      if (this.orderStatusResponse === 'success') {
        return 'Sucesso!';
      }
      if (this.orderStatusResponse === 'error') {
        return 'Erro.';
      }
      if (this.editMode) {
        return 'Concluindo edição';
      }
      return 'Fechar pedido';
    },
    formatAddress(address) {
      return `${address.address}${
        address.number !== 'null' || address.complement ? ',' : ''
      } ${address.number !== 'null' ? address.number : ''} ${
        address.complement ? `(${address.complement})` : ''
      } - ${address.region}, ${address.city}, ${this.getUfFromState(
        address.state
      )}`;
    },
    getUfFromState(state) {
      const states = {
        Acre: 'AC',
        Alagoas: 'AL',
        Amapá: 'AP',
        Amazonas: 'AM',
        Bahia: 'BA',
        Ceará: 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        Goiás: 'GO',
        Maranhão: 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        Pará: 'PA',
        Paraíba: 'PB',
        Paraná: 'PR',
        Pernambuco: 'PE',
        Piauí: 'PI',
        Roraima: 'RR',
        Rondônia: 'RO',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        'Santa Catarina': 'SC',
        'São Paulo': 'SP',
        Sergipe: 'SE',
        Tocantins: 'TO',
      };

      return states[state];
    },
    handleNextStepFinish() {
      if (this.currentStep === 0) this.currentStep = 1;
      this.$refs.salesfinish.nextStepFinish();
    },
    handlePrevStepFinish() {
      if (this.currentStep === 1) this.currentStep = 0;
      this.$refs.salesfinish.prevStepFinish();
    },
    getDrinkName(item) {
      return `${item.name} (${item.sizes[0].amount} ${item.sizes[0].unit})`;
    },
    async loadCatalog() {
      const response = await CatalogAPI.catalogCatalog(true, true);
      const catalog = Builder.mountSchema(
        response.getData({ type: 'catalog' })
      );

      Builder.executeOnSchema(catalog, (item) => {
        item.new = false;
        item.quantity = 0;
      });

      return catalog;
    },
    async handleOrder() {
      const { orderId } = this.$route.params;
      const orderResponse = await OrderApi.get(orderId);

      const { order } = orderResponse.getData({ order: null });
      this.editMode = true;
      this.order.id = orderId;
      this.pageTitle = 'Edição de pedido';
      this.pageSubtitle = `Pedido #${order.order_id}`;
      this.order.cart.catalog = Builder.mountSchema(order.cart.catalog);
      this.order.payment = order.payment;
      this.order.observation = order.observation;
      this.order.order_id = order.order_id;
      this.order.gift = order.gift;

      this.selectedCustomer = order.payment.payers[0].user || {};
      const customerId = this.selectedCustomer.id;

      if (customerId) {
        await this.getAddresses(customerId);
        // Se tiver um endereço de entrega selecionado
        if (order.delivery.address) {
          const addrId = order.delivery.address.id;
          this.selectedDeliveryAddress = -1;
          if (addrId) {
            for (const addrIdx in this.selectedCustomer.addresses) {
              if (this.selectedCustomer.addresses[addrIdx].id == addrId) {
                this.selectedDeliveryAddress = addrIdx;
                break;
              }
            }
          }
        }

        // Se opção retirada estiver ativa para o pedido em edição
        if (order.delivery.type === DeliveryType.GET_ON_PLACE) {
          this.selectedDeliveryAddress = -1;
        }
      }
    },
    async searchClientFromTel($event) {
      try {
        const phone = this.phone.replace(/[\(\)\-\ ]*/g, '');
        if (
          phone.length >= 11 ||
          (($event.keyCode == '13' || $event.type == 'blur') &&
            phone.length == 10)
        ) {
          if (phone.length == 11 && phone.charAt(2) != 9) {
            alert('Número inválido, celulares devem iniciar com dígito 9.');
            return;
          }

          if (
            this.phone != this.drawers.customer.phone ||
            $event.keyCode == '13'
          ) {
            this.drawers.customer.phone = this.phone;
            const response = await CustomerApi.GetFromPhone(phone, 'local');

            if (response.getErrors([]).length > 0) {
              this.drawers.customer.open = !this.drawers.customer.open;
              return;
            }

            const data = response.getData([]);
            this.customers = data || [];

            // Múltiplos clientes com mesmo número
            // if (data.length > 1) {
            //   this.selectedCustomer = null;
            //   this.drawers.customer.open = !this.drawers.customer.open;
            // }

            if (data.length >= 1) {
              this.selectedCustomer = data[0];
              await this.getAddresses(data[0].id);
            } else {
              this.selectedCustomer = { phone };
              this.drawers.customer.open = !this.drawers.customer.open;
            }
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    setCustomer(customer) {
      const newCustomerId = (customer && customer.id) || null;
      const selectedCustomerId =
        (this.selectedCustomer && this.selectedCustomer.id) || null;
      // Se o cliente selecionado é diferente da nova seleção de cliente
      if (newCustomerId != selectedCustomerId) {
        if (newCustomerId) {
          // Se a nova seleção de cliente é de fato um cliente
          this.selectedDeliveryAddress = customer.addresses.length > 0 ? 0 : -1;
        } else {
          // Senão seta o endereço selecionado para retirada no balcão
          this.selectedDeliveryAddress = -1;
        }
      }

      if (customer.id) {
        const customerIds = this.customers.map((c) => c.id);
        if (!customerIds.includes(customer.id)) {
          this.customers.push(customer);
        }
      }

      this.selectedCustomer = customer;

      this.getAddresses(customer.id);
    },
    async getAddresses(userId, index = '') {
      await CustomerApi.GetConfigurations(userId, false).then(
        (configurations) => {
          const addressesData = configurations.getData({
            addresses: [],
          }).addresses;
          this.$set(this.selectedCustomer, 'addresses', addressesData);

          const environmentAlias = getXAPIEnv();
          const { flags, annotations } = configurations.getData({
            flags: { [environmentAlias]: 0 },
          });
          const userFlags = flags[environmentAlias];

          if (annotations && annotations.length) {
            this.annotationsList = annotations
              .map((annotation) => annotation.annotation)
              .join('\n');
          }

          this.hasOrder =
            (userFlags & UserFlag.HAS_ORDER) == UserFlag.HAS_ORDER;
          this.hasAnnotation =
            (userFlags & UserFlag.HAS_ANNOTATION) == UserFlag.HAS_ANNOTATION;
          this.isBirthday =
            (userFlags & UserFlag.IS_BIRTHDAY) == UserFlag.IS_BIRTHDAY;
          this.hasIndicator =
            !this.hasOrder || this.hasAnnotation || this.isBirthday;

          if (addressesData.length > 0) {
            let lastDeliveryAddress = 0;

            addressesData.forEach((address, index) => {
              if (address.isLastSelected && address.isLastSelected === true) {
                lastDeliveryAddress = index;
              }
            });

            this.selectedDeliveryAddress = lastDeliveryAddress;
          }

          if (index != '') {
            this.selectedDeliveryAddress = index;
          }

          this.$set(
            this.selectedCustomer,
            'annotation',
            configurations.getData({ annotations: [null] }).annotations[0]
          );
        }
      );

      if (
        this.oldselectedDeliveryAddress !==
          this.selectedCustomer.addresses.length &&
        this.oldselectedDeliveryAddress !== 0
      ) {
        this.$refs.addressRef.value =
          this.selectedCustomer.addresses.length - 1;
      }
    },
    clearOrder() {
      this.clearSelection();
      this.order = this.createEmptyOrder();
    },
    clearAll() {
      if (this.$route.params.orderId) {
        delete this.$route.params.orderId;
        this.pageTitle = 'Atendimento';
        this.pageSubtitle = null;
        this.editMode = false;
      }

      this.clearOrder();
      this.hasOrder = false;
      this.isBirthday = false;
      this.hasAnnotation = false;
      this.annotationsList = 'Há anotações';
      this.hasIndicator = false;
      this.selectedCustomer = {};
      this.phone = this.configurations.phoneDDD
        ? `${this.configurations.phoneDDD} `
        : '';
      this.drawers.customer.phone = null;
      this.componentMounted = false;
      this.oldselectedDeliveryAddress = 0;
      this.order.payment.payers = [
        {
          changeFor: null,
          hasChange: false,
          method: 'MASTERCARD',
          paymentMethod: 17,
          status: 2,
        },
      ];
      this.order.payment.status = 0;
      this.order.payment.total = 0;
    },
    setSelectedDeliveryAddress(event) {
      this.componentMounted = true;
      if (this.componentMounted) {
        this.selectedDeliveryAddress = event.target.value;
      }
      if (String(event.target.value).length <= 0) {
        this.selectedDeliveryAddress = -1;
      }
    },
    createEmptyOrder() {
      return Order.fromObject({
        cart: {
          catalog: {
            type: 'catalog',
            edges: [],
            extra_ingredients: [],
            items: [],
          },
        },
        payment: {
          payers: [],
        },
        delivery: {},
        created_at: new Date(),
      });
    },
    changeTab(active) {
      this.tabOrder = active;

      if (!active) {
        this.cartAlert = false;
      }
    },
    getItems() {
      if (this.selectedCategory) {
        return this.selectedCategory.mode == 'pizza'
          ? this.selectedCategory.sizes
          : this.selectedCategory.items;
      }
      return this.getCategoryList();
    },
    getCategoryList() {
      return this.catalog && this.catalog.items ? this.catalog.items : [];
    },
    selectCategory(category) {
      this.selectedCategory = category;
      // Lógica para quando houver apenas uma um tamanho ir direto para o drawer
      // if (
      //   this.selectedCategory.mode == "pizza" &&
      //   this.selectedCategory.sizes.length == 1
      // ) {
      //   this.selectProduct(this.selectedCategory.sizes[0]);
      // }
    },
    selectProduct(product) {
      if (this.selectedCategory.mode == 'pizza') {
        const pizzaProduct = Builder.factory('Pizza');
        pizzaProduct.name = product.name;
        pizzaProduct.max_flavors = product.max;

        pizzaProduct.doughs = this.selectedCategory.doughs.filter((dough) => {
          dough.quantity = 0;
          return dough.sizes.filter((s) => s._id == product._id).length > 0;
        });

        pizzaProduct.edges = this.selectedCategory.edges.filter((edge) => {
          edge.quantity = 0;
          return edge.sizes.filter((s) => s._id == product._id).length > 0;
        });

        pizzaProduct.items = this.selectedCategory.items.filter((item) => {
          item.quantity = 0;
          return item.sizes.filter((s) => s._id == product._id).length > 0;
        });

        pizzaProduct.extra_ingredients =
          this.selectedCategory.extra_ingredients.filter((extra) => {
            extra.quantity = 0;
            return extra.sizes.filter((s) => s._id == product._id).length > 0;
          });

        this.selectedProduct = this.cloneObject(pizzaProduct);

        // //Remove todos o tamanhos que não são o selecionado
        Builder.executeOnSchema(this.selectedProduct, (item) => {
          Vue.set(
            item,
            'sizes',
            item.sizes.filter((s) => s._id == product._id)
          );
        });
      } else {
        this.selectedProduct = product;
        Builder.executeOnSchema(this.selectedProduct, (item) => {
          item.quantity = 0;
        });
        this.selectedProduct.quantity = 1;
      }

      this.drawers.order.open = !this.drawers.order.open;
    },
    clearSelection() {
      this.selectedCategory = null;
      this.selectedProduct = null;
    },
    clearSelectionProduct() {
      this.selectedProduct = null;
    },
    addItem(product) {
      this.order.cart.catalog.addItems(this.cloneObject(product));
      this.order.cart.total =
        parseFloat(this.order.cart.total) + parseFloat(product.price);

      this.$nextTick(() => {
        const scrollElement = document.querySelector('#cartContent');
        if (scrollElement) {
          scrollElement.scrollIntoView({ behavior: 'smooth' });
        }

        this.$refs.salesOrder.closeDrawer();
      });

      this.clearSelection();
    },
    cloneObject(obj) {
      return Builder.mountSchema(JSON.parse(JSON.stringify(obj)));
    },
    getRadiusMinOrder(addressGeolocation) {
      if (!addressGeolocation) {
        return 0;
      }

      const restaurantGeo = Geolocation.fromObject(
        this.configurations.location.geolocation
      );
      const samePlace =
        restaurantGeo.latitude == addressGeolocation.latitude &&
        restaurantGeo.longitude == addressGeolocation.longitude;
      const distance = samePlace
        ? 0
        : restaurantGeo.distanceTo(addressGeolocation) / 1000;

      const deliveryRegions = this.configurations.delivery_region;
      const radiusStrips = deliveryRegions.filter(
        (region) => +region.up_to >= +distance
      );

      radiusStrips.sort((a, b) => +a.up_to <= +b.up_to);

      return radiusStrips[0] ? +radiusStrips[0].min_order : false;
    },
    finish(order) {
      const sendOrder = async (confirmedOrder) => {
        this.$refs.salesfinish.showLoading(true);
        this.hideFooter = true;

        const response = confirmedOrder.id
          ? await OrderApi.update(confirmedOrder.id, confirmedOrder)
          : await OrderApi.checkout(confirmedOrder);

        if (response.getErrors([]).length > 0) {
          this.orderStatusResponse = 'error';
          this.$refs.salesfinish.showResponse(this.orderStatusResponse);
          this.hideFooter = false;
        } else {
          const data = response.getData() || [];
          if (Utils.empty(data) || data.length == 0) {
            this.orderStatusResponse = 'error';
            this.$refs.salesfinish.showResponse(this.orderStatusResponse);
            this.hideFooter = false;
          } else {
            if (order.id) {
              alert('Edição realizada com sucesso!');
              router.push({ name: 'pedidos' });

              const { order_id, created_at } = this.order;
              Object.assign(order, { order_id, created_at });

              if (DesktopBridge.isDesktop()) {
                await this.print(order, 'whenEditingOrders');
              }
            } else {
              const {
                checkout: { order_id, created_at },
              } = data;

              Object.assign(confirmedOrder, { order_id, created_at });

              // salvando o endereço selecionado
              if (confirmedOrder.delivery.address) {
                const customerResponse =
                  await CustomerApi.setLastDeliveryAddress(
                    this.selectedCustomer.id,
                    confirmedOrder.delivery.address.id
                  );

                if (customerResponse.getErrors([]).length > 0) {
                  this.orderStatusResponse = 'error';
                  this.$refs.salesfinish.showResponse(this.orderStatusResponse);
                  this.hideFooter = false;
                }
              }

              this.$refs.salesfinish.showLoading(false);
              this.hideFooter = false;
              this.orderStatusResponse = 'success';
              this.$refs.salesfinish.showResponse(this.orderStatusResponse);

              confirmedOrder.position = response._data.checkout.position;

              this.clearAll();
              await this.print(
                JSON.parse(JSON.stringify(confirmedOrder)),
                Object.keys(this.selectedCustomer).length == 0
                  ? 'whenOrderingByServiceDesk'
                  : 'whenOrderingByPhone'
              );
            }

            this.clearAll();
          }
        }
      };

      const minOrder = order.delivery.address
        ? this.getRadiusMinOrder(order.delivery.address.geolocation)
        : 0;

      if (minOrder <= order.cart.total) {
        if (order.delivery.address) {
          delete order.delivery.address.isLastSelected;
        }
        sendOrder(order);
      } else if (minOrder > order.cart.total) {
        confirm(
          'Pedido mínimo não atingido, deseja finalizar mesmo assim?'
        ).then((r) => !!r && sendOrder(order));
      } else {
        alert('Pedido fora da região de entrega!');
      }
    },
    async print(order, actionTrigger) {
      const cloneOrder = JSON.parse(JSON.stringify(order));

      cloneOrder.cart.catalog.items.map((item) => {
        const parentId = ['simple', 'step', 'drink'].includes(item.type)
          ? item.parent
          : item.items[0].parent;
        const categoryName = this.catalog.getItemsByParam('_id', parentId)[0]
          .name;

        item.categoryName = categoryName;
      });

      if (DesktopBridge.isDesktop()) {
        await DesktopPrint(cloneOrder, 'pedidos', actionTrigger);
        return;
      }

      const dataPrint = await DesktopPrint(
        cloneOrder,
        'pedidos',
        actionTrigger
      );
      AppBridge.emit('printData', dataPrint);
    },
    recalculeCart(cart) {
      let total = 0;
      cart.catalog.items.forEach((item) => {
        total += item.getPrice();
      });

      cart.total = parseFloat(total.toFixed(2));
    },
    openCheckout() {
      this.drawers.cart.close = !this.drawers.cart.close;
      setTimeout(() => {
        this.drawers.finish.show = true;
        this.drawers.finish.open = !this.drawers.finish.open;
      }, 250);
    },
    validCheckout() {
      const zeroQuantityItem = this.order.cart.catalog.items.find(
        (item) => !item.quantity
      );

      if (zeroQuantityItem) {
        return alert(StringLanguage.zeroQuantityItem);
      }

      this.drawers.finish.show = true;
      this.drawers.finish.open = !this.drawers.finish.open;
    },
    onCloseCustomerDrawer() {
      if (!this.selectedCustomer || !this.selectedCustomer.id) {
        this.selectedCustomer = {};
        this.phone = this.configurations.phoneDDD
          ? `${this.configurations.phoneDDD} `
          : '';
        this.drawers.customer.phone = null;
      }
    },
    onChangeCartItemQuantity(itemIndex, newQuantity) {
      this.order.cart.catalog.items[itemIndex].quantity = newQuantity;

      // se estiver exibindo excluir e adicionar quantidade, para de exibir
      if (this.removeItems.includes(itemIndex) && newQuantity > 0) {
        this.removeItems = this.removeItems.splice(itemIndex, 1);
      }
    },
    onRemoveCartItem(itemIndex, product) {
      this.order.cart.catalog.items.splice(itemIndex, 1);
      Storage2.set('session', 'order', this.order);

      // removendo do carrinho, remove da lista de exibição do excluir
      this.removeItems = this.removeItems.splice(itemIndex, 1);
    },
  },
  watch: {
    'order.cart.catalog.items.length': {
      deep: true,
      handler(newValue) {
        if ((this.removeItems || []).length && newValue == 0) {
          this.removeItems = [];
        }

        if (newValue > this.tabs[1].count) {
          this.cartAlert = true;
        }

        this.tabs[1].count = newValue;

        if (newValue < 1) {
          this.drawers.cart.close = !this.drawers.cart.close;
        }
      },
    },
    order: {
      deep: true,
      handler(newValue) {
        this.recalculeCart(newValue.cart);
      },
    },
    configurations: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue && newValue.phoneDDD && !this.phone) {
          this.phone = `${newValue.phoneDDD} `;
        }
      },
    },
    'drawers.customer.open': function () {
      this.oldselectedDeliveryAddress = this.selectedCustomer.addresses.length;
      this.drawers.customer.index = this.drawers.customer.index + 1;
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      configurations: (state) => state.store.configurations,
      onBoardDone: (state) => state.store.onBoardDone,
    }),
  },
};
</script>

<style scoped>
#catalog > #cart {
  padding-left: 5px;
}
.customer-box {
  display: flex;
}
.customer-search,
.customer-found {
  width: 100%;
  display: flex;
  padding-top: 25px;
  margin-bottom: 30px;
}
.customer-icon {
  color: #ff478f;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-size: 34px;
  margin-right: 20px;
  margin-bottom: 3px;
}
.customer-found .customer-icon {
  margin-bottom: 0;
}
.construction {
  margin-bottom: 0;
  height: calc(100vh - 333px);
  position: relative;
}
.cart {
  height: calc(100vh - 213px);
  margin-bottom: 0;
  padding-bottom: 60px;
}
.cart-content {
  max-height: calc(100% - 140px);
  overflow: auto;
  margin: 10px -15px;
  padding: 0 15px;
}
.cart .cc-title {
  padding-bottom: 5px;
  margin-bottom: 0px;
  margin: -20px 0;
  margin-bottom: 0;
  padding: 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #ffffff1f;
}
.cc-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.action-right {
  cursor: pointer;
  margin-bottom: 3px;
  color: #fff;
  font-size: 1.2em;
  text-transform: uppercase;
}
.action-right + div {
  opacity: 0;
  height: 1px;
  background-color: #fff;
}
.action-right:hover + div {
  opacity: 1;
}
.box-selection {
  border: 1px solid var(--input-border);
  color: #aaaaab;
  text-align: center;
  font-size: 1.2em;
  font-weight: 400;
  padding: 17px 25px;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

@media (pointer: fine) {
  .box-selection:hover {
    border-color: #ff3382c9;
    color: var(--default);
    font-weight: bold;
    transition: all 0.1s ease;
  }
}

.box-selection .name {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.5;
}

.box-selection .price {
  margin-top: 10px;
  font-size: 0.8em;
  font-weight: 900;
}

.box-selection .qty {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 4px 6px;
  font-size: 0.7em;
  background: var(--default);
  border-radius: 100%;
  color: white;
  font-weight: 900;
}

.customer-found {
  width: 100%;
  display: flex;
}

.customer-main {
  display: flex;
  align-items: center;
  padding-right: 25px;
  cursor: pointer;
  color: #aaaaab;
}

.block-edit .customer-main {
  cursor: not-allowed !important;
}

.customer-name {
  font-size: 1.4em;
  margin-bottom: 10px;
  max-width: 245px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customer-found .customer-name {
  font-weight: bold;
}

.customer-found .customer-name,
.customer-found .customer-phone {
  color: var(--default);
  align-items: center;
  display: flex;
}

.customer-phone {
  font-size: 1.2em;
  white-space: nowrap;
}

.customer-verify {
  font-size: 1.3em;
  color: #0ba584;
  margin-top: 1px;
  margin-left: 5px;
}

.finish-order {
  position: absolute;
  bottom: 0;
  flex: 1;
  left: 0;
  right: 0;
  width: 100%;
  padding: 20px;
}

.finish-order .total {
  margin: -20px 0 0px;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #ffffff12;
}

.finish-order .total p:first-child {
  color: #aaaaab;
  font-size: 1.2em;
}
.finish-order .total p:last-child {
  color: #cccccc;
  font-size: 1.6em;
  font-weight: 900;
}

.finish-order button {
  width: 100%;
}

.empty-catalog,
.empty-cart {
  position: absolute;
  width: calc(100% - 40px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
  color: #8c8c8c;
  font-weight: 300;
}

.empty-cart {
  top: 60px;
  height: 80%;
  display: flex;
  flex-direction: column;
}

.empty-cart i.fa-shopping-cart {
  font-size: 21px;
  margin-bottom: 15px;
}

.empty-catalog {
  flex-direction: column;
  height: calc(100% - 140px);
}

.empty-catalog .link-catalog {
  color: var(--default);
  margin-top: 20px;
  padding-bottom: 5px;
  border-bottom: 1px solid;
  text-decoration: none;
  font-weight: 500;
}

.cart-mobile {
  position: fixed;
  height: 45px;
  width: 100vw;
  right: 0;
  bottom: 60px;
  background: var(--default);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2em;
  color: white;
  padding: 15px 25px;
}
.box-categories {
  margin: 10px -7.5px 0 -7.5px;
  height: calc(100% - 55px);
  overflow-y: auto;
}
.box-categories > div {
  padding: 0 7.5px;
}

.cart-mobile p:first-child,
.cart-mobile p:last-child {
  width: 20vw;
}

.cart-mobile p:last-child {
  font-weight: bold;
}

.itens-qty {
  width: 15px;
  height: 15px;
  padding: 2px 6px;
  background: #fff;
  color: var(--default);
  border-radius: 50%;
}

.indicator {
  color: #ffcc99;
  font-size: 12px;
}

.indicator:not(:last-child) {
  margin-right: 10px;
}

/* RESPONSIVO */
@media screen and (max-width: 991px) {
  .customer-found {
    display: block;
    height: auto;
  }
  .customer-main {
    width: 100%;
    height: auto;
    margin-bottom: 0px;
  }

  .customer-search,
  .customer-found {
    padding-top: 20px;
    margin-bottom: 20px;
  }

  .customer-found .customer-icon {
    margin-top: 3px;
  }

  .customer-search {
    padding-bottom: 15px;
  }

  .customer-name {
    max-width: calc(100vw - 190px);
  }

  .construction,
  .cart {
    min-height: 140px;
    height: auto;
    position: static;
  }

  .construction.empty,
  .cart.empty {
    min-height: 200px;
  }

  .type-box {
    margin-right: 20px;
  }

  .empty-catalog,
  .empty-cart {
    margin-top: 20px;
  }

  .empty-catalog {
    height: 55vh;
    position: static;
    width: 100%;
  }

  .cart-alert {
    background: var(--error);
    color: #fff;
    width: 15px;
    height: 15px;
    position: absolute;
    top: -4px;
    right: -4px;
    border-radius: 100%;
  }
}
</style>
